import {
  AutomobileMaintenancePart,
  AutomobileMaintenanceParts,
} from '@/reports/types/vehicles';
import { Text, Table, useTheme } from '@/theme/index';
import { commaFormatCurrency } from '@/utils/index';

interface DesktopRepairQuotePartsProps {
  parts: AutomobileMaintenanceParts;
}

export const DesktopRepairQuoteParts = ({
  parts,
}: DesktopRepairQuotePartsProps) => {
  const theme = useTheme();
  const headerRowStyle = () => ({
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    fontWeight: 'bold',
    textAlign: 'left',
  });

  const buildRows = () => {
    if (parts.length <= 0) return [];
    return parts.map((item: AutomobileMaintenancePart) => {
      return [
        <Text fontWeight="bold" variant="body2">
          {item.description} - {item.category}
        </Text>,
        `${item.type || '-'}`,
        `${item.quantity || '-'}`,
        `${(Boolean(item.price) && commaFormatCurrency(item.price)) || '-'}`,
      ];
    });
  };

  return (
    <Table
      data-cy="desktop-repair-quote-parts-table"
      className="striped"
      headerRowStyle={headerRowStyle()}
      headers={['Description', 'Type', 'Quantity', 'Price']}
      rows={buildRows()}
    />
  );
};
